import React, { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";

export default function ProgressBar({ duration = 5000, sx }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const intervalTime = 50;
    const step = (intervalTime / duration) * 100;

    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + step;
        if (next >= 100) {
          clearInterval(interval);
          return 100;
        }
        return next;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [duration]);

  return (
    <LinearProgress
      variant="determinate"
      value={progress}
      sx={{
        height: 6,
        borderRadius: 4,
        backgroundColor: "#CAEDE7",
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#5CB89F",
        },
        ...sx,
      }}
    />
  );
}